(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cleanups = new Map();
  function dispose(root) {
    cleanups.forEach(function (cleanup, element) {
      if (element === root || root.contains(element)) {
        cleanup();
        cleanups.delete(element);
      }
    });
  }
  function init(root) {
    root.querySelectorAll('[data-theme-toggle][data-label-dark]').forEach(function (button) {
      if (button.dataset.labelBound) return;
      button.dataset.labelBound = 'true';
      var active = true;
      function syncLabel() {
        if (!active) return;
        var theme = document.documentElement.getAttribute('data-theme');
        var dark = theme ? theme === 'dark' : document.documentElement.classList.contains('dark');
        var label = dark ? button.dataset.labelLight : button.dataset.labelDark;
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      }
      syncLabel();
      var observer = new MutationObserver(syncLabel);
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'data-theme'] });
      cleanups.set(button, function () {
        active = false;
        observer.disconnect();
        delete button.dataset.labelBound;
      });
    });
    root.querySelectorAll('.eh-steps, .sap-pdp__step-list, .sap-how__steps, .erp-simple-steps').forEach(function (list) {
      if (list.dataset.sequenceBound) return;
      list.dataset.sequenceBound = 'true';
      list.classList.add('erp-step-sequence');
      Array.from(list.children).forEach(function (step, index) {
        step.style.setProperty('--step-delay', (index * 1.4) + 's');
      });
      var active = true;
      var observer = null;
      var onReducedChange = null;
      cleanups.set(list, function () {
        active = false;
        if (observer) observer.disconnect();
        if (onReducedChange) reduced.removeEventListener('change', onReducedChange);
        delete list.dataset.sequenceBound;
      });
      if (!('IntersectionObserver' in window)) return;
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!active) return;
          list.classList.toggle('is-in-view', entry.isIntersecting && !reduced.matches);
        });
      }, { threshold: 0.25 });
      observer.observe(list);
      onReducedChange = function () { if (active && reduced.matches) list.classList.remove('is-in-view'); };
      reduced.addEventListener('change', onReducedChange);
    });
    var content = root.querySelector('.erp-policy-shell .shopify-policy__body');
    var nav = root.querySelector('[data-policy-toc]');
    if (content && nav && !nav.dataset.bound) {
      nav.dataset.bound = 'true';
      var headings = Array.from(content.querySelectorAll('h2'));
      if (headings.length > 3) {
        headings.forEach(function (heading, i) {
          if (!heading.id) heading.id = 'policy-section-' + (i + 1);
          var a = document.createElement('a');
          a.href = '#' + heading.id;
          a.textContent = heading.textContent;
          nav.appendChild(a);
        });
        nav.hidden = false;
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { dispose(e.target); });
}());
